module.exports = __webpack_public_path__ + "img/app.e56b2ba7.png";